import { Box, Button, TextField, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { trackClickedPowerListUploadContactsButton } from '../../../common/userTracking';

const useStyles = makeStyles((theme: Theme) => ({
  field: {
    marginTop: theme.spacing(1), // space between fields
    marginBottom: theme.spacing(1), // space between fields
    // '& .MuiFormLabel-root[data-shrink=false]': {
    //   lineHeight: 0.25, // adjust label position after field height
    // },
    // '& .MuiInputBase-input': {
    //   padding: '14px 12px', // shrink field height
    // },
    // TODO: move to theme
    '& .MuiFormHelperText-root': {
      marginLeft: 0, // adjust helper text
    },
    '& .MuiInputLabel-root[data-shrink=false]': {
      opacity: 0.5, // make placeholder lighter
    },
  },
  fileUploadLabel: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
    height: 'min-content',
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
    '& .MuiButton-label': {
      padding: 2,
    },
  },
  audioContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  audio: {
    transition: 'all 0.5s linear',
    boxShadow: '0px 0px 0px 0px',
    backgroundColor: '#f0f3f4',
    borderRadius: '7px 7px 7px 7px',
    height: 32,
    maxWidth: '-webkit-fill-available',
    margin: '0px auto',
    '&:focus': {
      outline: 0,
    },
  },
  labelledOutline: {
    marginTop: theme.spacing(1),
  },
}));

export const UploadFiles = ({ formik, uploadFile }: any) => {
  const classes = useStyles();

  return (
    <fieldset className={classes.audioContainer}>
      <Box display="flex">
        <label htmlFor="dataUpload.id">
          <Button
            component="span"
            variant="contained"
            color="primary"
            className={classes.button}
            disableElevation
            onClick={() => {
              if (window.location.href.includes('powerlists')) {
                trackClickedPowerListUploadContactsButton();
              }
            }}
          >
            Select File
          </Button>
        </label>
        <TextField
          className={`flex-grow-1 ${classes.field}`}
          disabled={true}
          label="Filename"
          value={formik?.values?.powerlistSpreadsheets[0]?.name || ''}
          variant="outlined"
          size="small"
        />
      </Box>
      <input
        id="dataUpload.id"
        name="dataUpload"
        data-pup="powerlist-data-upload-input"
        type="file"
        accept=".xls,.xlsx,.csv"
        hidden={true}
        multiple={false}
        onChange={(event: any) => {
          formik.setFieldValue(
            'powerlistSpreadsheets[0].name',
            event.target.files[0].name
          );
          uploadFile(event.target.files[0]);
        }}
      />
    </fieldset>
  );
};
